import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { SeatSelectedAction, SeatsSelected } from '../../models/seats-selected';
import { SyosPriceLevel } from '../../models/syos-price-level';
import { SyosSeatStatus } from '../../models/syos-seat-status';
import { SyosSeatDetail } from '../../models/syos-seat-detail';
import { SyosVenueDetails } from '../../models/syos-venue-details';
import { PriceWeb } from '../../models/price-web';
import { SyosSection } from '../../models/syos-section';
import { SyosSeat } from '../../models/syos-seat';
import { cloneObjectHelps, deleteSeatsSelected, filterParmsByWhiteList } from '../../utils/utilsShared';
import { AnalyticsService } from '../../../../../../src/modules/shared/services/analytics.service';
import { Cart } from '../../models/cart';
import { DrawSeatMapsService } from './draw-seat-maps.service';

export enum TypeApi {
    FULL = 'full',
    POLYGONS = 'polygons',
    DEFAULT = '',
}

@Injectable({
    providedIn: 'root',
})
export class SeatMapService {
    subQtyBySelecte = new BehaviorSubject<number>(1);
    subQtyTotalHasRigthSelectedInSeatMap = new BehaviorSubject<{
        min: number;
        max: number;
    }>({ min: -1, max: -1 });
    subBestSeat = new Subject<boolean>();
    subSeatSelected = new BehaviorSubject<SeatsSelected[]>(null);
    listSeatsSelected: SeatsSelected[] = [];
    subOptionMultiSelect = new BehaviorSubject<boolean>(true);
    subValidQtyDemande = new BehaviorSubject<boolean>(false);
    subHideMenuSelectSeatMap = new BehaviorSubject<boolean>(false);
    priceLevelSelectedId!: number;
    MIN_SHOW_POLYGON = 4100; //cette option doit retourne par le backend
    smallSeatsMap = true;
    MIN_SHOW_SEATS = 500;
    subDrawByFilterPriceLevels = new BehaviorSubject<number[]>(null);
    subSeatSelectedToRemove = new BehaviorSubject<{
        eventdId?: any;
        seats: SeatsSelected[];
        oberve?: boolean;
    }>(null);
    subSeatSelectedAction = new BehaviorSubject<Partial<SeatSelectedAction>>(null);
    whiteListPageParameter = [
        'promo',
        'presale',
        'displayOnlyPromo',
        'serviceChargeType',
        'seatStatus',
        'displayPromoBox',
        'flexpassId',
        'taxIncluded',
        'search',
        'options',
    ];

    subSeatSelectedToRemoveLast = new BehaviorSubject<any>(null);
    subCart = new BehaviorSubject<Cart>(null);
    constructor(
        private http: HttpClient,
        private analyticsService: AnalyticsService,
    ) {}

    watchQtySeatMapBySelect(): Observable<number> {
        return this.subQtyBySelecte.asObservable();
    }

    watchSubBestSeatSelect(): Observable<boolean> {
        return this.subBestSeat.asObservable();
    }

    watchSeatSelected(): Observable<SeatsSelected[]> {
        return this.subSeatSelected.asObservable();
    }
    resetSubSeatSelected(val: SeatsSelected[] = [], oberve = true) {
        const listSeatsSelected = cloneObjectHelps(val);
        if (oberve) {
            this.subSeatSelected.next(listSeatsSelected ? listSeatsSelected : []);
        }
        this.listSeatsSelected = listSeatsSelected ? listSeatsSelected : [];
   
    }
    getSubSeatSelectedValue() {
        return this.listSeatsSelected;
    }

    addSubSeatSelected(seatsSelected: SeatsSelected) {
        if (seatsSelected) {
            this.priceLevelSelectedId = seatsSelected.priceLevelId;
        }
        let list = <SeatsSelected[]>this.getSubSeatSelectedValue();
        if (!list) {
            list = [];
        }
        let seats = JSON.parse(JSON.stringify(seatsSelected));
        list.push(seats);
        this.analyticsService.trackItemSelection(seats.prices);
        this.resetSubSeatSelected(list);
        this.subSeatSelectedAction.next({ type: 'add', seatsSelected: [seats] });
    }
    regroupSubSeatSelectedBuyPrice(seatsSelected?: SeatsSelected[]) {
        let list = cloneObjectHelps(<SeatsSelected[]>this.getSubSeatSelectedValue());
        /* IL CREE PROBLAME DE REFERNCE DANS BT FLOATING*/
        // if (seatsSelected) {
        //     list = seatsSelected;
        // }
        if (!list) {
            list = [];
        }
        const newLists = [];
        list.forEach((value) => {
            if (newLists.length === 0) {
                newLists.push(value);
            } else {
                const find = newLists.find(
                    (v) => v.priceLevelId === value.priceLevelId && v.eventId === value.eventId && v.prices[0].id === value.prices[0].id,
                );
                if (find) {
                    find.seatIds = [...new Set([...find.seatIds, ...value.seatIds])];
                    find.prices[0].qty = find.seatIds.length;
                    find.prices[0].seatIds = find.seatIds;
                } else {
                    newLists.push(value);
                }
            }
        });
        console.log(newLists);
        return {
            list: newLists,
            qty: newLists.reduce((acc, value) => acc + value.seatIds.length, 0),
        };
    }

    removeSubSeatSelected(seatsSelected: SeatsSelected, eventId?: any) {
        let list = <SeatsSelected[]>this.getSubSeatSelectedValue();
        if (!list) {
            list = [];
        }
        if (eventId) {
            list = list.filter((value) => value.eventId === eventId);
        }
        list = list.filter((value) => value.seatIds.join('-') !== seatsSelected.seatIds.join('-'));
       
        this.resetSubSeatSelected(list);
        this.subSeatSelectedAction.next({ type: 'remove', seatsSelected: cloneObjectHelps([seatsSelected]), eventId: eventId });
    }
    isSelectedSeat(seatId: number): boolean {
        let list = <SeatsSelected[]>this.getSubSeatSelectedValue();
        if (!list) {
            list = [];
        }
        return list.some((value) => value.seatIds.includes(seatId));
    }
    getSubSeatSelected(eventId?: any): SyosSeat[] {
        let seatsSelected = <SeatsSelected[]>this.getSubSeatSelectedValue();
        let newS: SyosSeat[] = [];
        if (eventId) {
            seatsSelected = seatsSelected.filter((value) => value.eventId === eventId);
        }
        seatsSelected?.forEach((value) => {
            newS = [...newS, ...value.data];
        });

        return newS;
    }
    getGroupSeatSelected(eventId?: any): SeatsSelected[] {
        let seatsSelected = <SeatsSelected[]>this.getSubSeatSelectedValue();
        let newS: SyosSeat[] = [];
        if (eventId) {
            seatsSelected = seatsSelected.filter((value) => value.eventId === eventId);
        }

        return seatsSelected;
    }
    getFormatSubSeatSelected(listRemoved: SeatsSelected[], seatId?: any): SyosSeat[] {
        let newS: SyosSeat[] = [];
        if (seatId) {
            listRemoved
                .filter((value) => value.seatIds.includes(seatId))
                .forEach((value) => {
                    newS = [...newS, ...value.data];
                });
            return newS;
        }
        listRemoved?.forEach((value) => {
            newS = [...newS, ...value.data];
        });
        return newS;
    }

    getPriceSeatSelected(): PriceWeb[] {
        const listRemoved = <SeatsSelected[]>this.getSubSeatSelectedValue();
        let newS: PriceWeb[] = [];

        listRemoved?.forEach((value) => {
            newS = [...newS, ...value.prices];
        });
        return newS;
    }
    getFormatToPrice(listRemoved: SeatsSelected[]): PriceWeb[] {
        const data = this.regroupSubSeatSelectedBuyPrice(listRemoved);
        let newS: PriceWeb[] = [];
        console.log(data);
        data.list?.forEach((value) => {
            newS.push(value.prices[0]);
        });
        console.log(newS);
        return newS;
    }

    removeSubSeatSelectedById(id: number, oberve = true): SyosSeat[] {
        let list: SeatsSelected[] = cloneObjectHelps(<SeatsSelected[]>this.getSubSeatSelectedValue());
        if (!list) {
            list = [];
        }
        /* Change temporairement les seatIds pour correspondre aux ids du tableau data afin de faciliter la suppression basée sur le seatId
        Cette opération est nécessaire car le premier prix inclut tous les sièges sélectionnés pour un niveau de prix, nécessaire pour le holding */
        list.forEach((value) => {
            value.seatIds = value.data.map((v) => v.id);
        });
        const temp = list.filter((seatsSelected) => !seatsSelected.seatIds.includes(id));
        if (temp.length === list.length) {
            return [];
        }
        this.resetSubSeatSelected(temp, oberve);
        const listRemoved = list.filter((seatsSelected) => seatsSelected.seatIds.includes(id));
        let newS: SyosSeat[] = [];
        listRemoved.forEach((value) => {
            newS = [...newS, ...value.data];
        });
        return newS;
    }
    clearSubSeatSelected(eventId?: any) {
        let list = <SeatsSelected[]>this.getSubSeatSelectedValue();
        if (!list) {
            return;
        }
        list?.filter((value) => value.eventId !== eventId);
        this.resetSubSeatSelected(list.filter((value) => value.eventId !== eventId));
    }

    getPriceLevel(priceLevels: SyosPriceLevel[] | any, pricesLevelId): SyosPriceLevel {
        let temp = null;
        if (!priceLevels) {
            return temp;
        }
        priceLevels.forEach((per) => {
            if (per.id === pricesLevelId) {
                temp = per;
                return temp;
            }
        });
        return temp;
    }

    getSeatStatus(seatStatus: SyosSeatStatus[], seatStatusId): SyosSeatStatus {
        let temp = null;
        if (!seatStatus) {
            return temp;
        }
        seatStatus.forEach((sets) => {
            if (sets.id === seatStatusId) {
                temp = sets;
                return temp;
            }
        });
        return temp;
    }

    getPriceForSeatBySectionId(Id, sectionId, isSubscription = false, httpParams?: HttpParams): Observable<SyosSeatDetail[]> {
        if (!Id) {
            return of([]);
        }
        if (isSubscription) {
            return this.http.get<SyosSeatDetail[]>('v1/seatmap/subscription/' + Id + '/section/' + sectionId + '/details', {
                params: httpParams,
            });
        }
        return this.http.get<SyosSeatDetail[]>('v1/seatmap/event/' + Id + '/section/' + sectionId + '/details', { params: httpParams });
    }

    getPriceLevelsForSeatsMap(eventId, httpParams?: HttpParams): Observable<SyosVenueDetails> {
        return this.http.get<SyosVenueDetails>('v1/seatmap/event/' + eventId + '/full', { params: httpParams });
    }

    formatToPrices(seatsSelected: SeatsSelected): PriceWeb[] {
        const prices = [];
        seatsSelected.data.forEach((seat) => {
            const price = seat.priceSelected;
            const key = price.id;
            const temp = prices[key];
            if (temp) {
                prices[key][0].seatIds.push(seat.id);
                prices[key][0].total = 0;
            } else {
                prices[key] = [];
                price.seatIds = [];
                price.seatIds.push(seat.id);
                price.total = 0;
                prices[key].push(price);
            }
        });
        const dataFormPrices: PriceWeb[] = [];

        Object.keys(prices).forEach(function (key) {
            prices[key][0].qty = prices[key][0].seatIds.length;
            prices[key][0].total = (prices[key][0].serviceCharges + prices[key][0].price) * prices[key][0].qty;
            dataFormPrices.push(prices[key][0]);
        });
        return dataFormPrices;
    }

    getPolygons(Id, isSubscription = false, httpParams?: HttpParams): Observable<SyosVenueDetails> {
        let filteredParams = filterParmsByWhiteList(httpParams, this.whiteListPageParameter);

        if (isSubscription) {
            return this.http.get<SyosVenueDetails>('v1/seatmap/subscription/' + Id + '/polygons', { params: filteredParams });
        }
        return this.http.get<SyosVenueDetails>('v1/seatmap/event/' + Id + '/polygons', { params: filteredParams });
    }

    getVenueFull(Id, isSubscription = false, httpParams?: HttpParams): Observable<SyosVenueDetails> {
        let filteredParams = filterParmsByWhiteList(httpParams, this.whiteListPageParameter);

        if (!Id) {
            return this.http.get<SyosVenueDetails>('v1/seatmap/event/' + Id + '/full', { params: filteredParams });
        }
        if (isSubscription) {
            return this.http.get<SyosVenueDetails>('v1/seatmap/subscription/' + Id + '/full', { params: filteredParams });
        }
        return this.http.get<SyosVenueDetails>('v1/seatmap/event/' + Id + '/full', { params: filteredParams });
    }

    getVenueAdmin(venueId, isPolygon = true, httpParams = new HttpParams()) {
        if (isPolygon) {
            return this.http.get<SyosVenueDetails>('v1/seatmap/venues/' + venueId + '/polygons', { params: httpParams });
        }
        return this.http.get<SyosVenueDetails>('v1/seatmap/venues/' + venueId + '/full', { params: httpParams });
    }

    getSection(id: string, typeApi?: TypeApi): Observable<SyosSection> {
        const t = 10 * 60 * 1000;
        let httpParams = new HttpParams();
        httpParams = httpParams.set('cache', String(t));
        const temp = typeApi ? '/' + typeApi : '';
        return this.http.get<SyosSection>(`v1/seatmap/sections/${id}${temp}`, {
            params: httpParams,
        });
    }

    addDrawByFilterPriceLevels(priceLevelId: number) {
        let list = this.subDrawByFilterPriceLevels.value;
        if (!list) {
            list = [];
        }
        if (!list.includes(priceLevelId)) {
            list.push(priceLevelId);
            this.subDrawByFilterPriceLevels.next(list);
        }
    }

    removeDrawByFilterPriceLevels(priceLevelId: number) {
        let list = this.subDrawByFilterPriceLevels.value;
        if (!list) {
            return;
        }
        list = list.filter((value) => value !== priceLevelId);
        this.subDrawByFilterPriceLevels.next(list);
    }

    getDrawByFilterPriceLevels(): number[] {
        return this.subDrawByFilterPriceLevels.value;
    }
    watchSubCart(): Observable<Cart> {
        return this.subCart.asObservable();
    }
    getSubCart(): Cart {
        return this.subCart.value;
    }
    setSubCart(cart: Cart) {
        this.subCart.next(cart);
    }
    removeSeatReserveTemp(seat: SyosSeat, oberve = true) {
            if (!seat) {
                return;
            }
            const hasSeatToRemove = this.removeSubSeatSelectedById(seat.id, oberve);
            DrawSeatMapsService.removeStyleForHoverOrSelectSeat(hasSeatToRemove, true);
            this.subSeatSelectedAction.next({type: 'remove', seats: cloneObjectHelps(hasSeatToRemove) });
    }
    removeAllSeatReserveTemp(oberve = false){
        const list = this.getSubSeatSelected();
        if (!list) {
            return;
        }
        list.forEach((seat) => {
            this.removeSeatReserveTemp(seat, oberve);
        });
    }
    getSeatById(seatId: any): SyosSeat {
        const list = this.getSubSeatSelected();
        if (!list) {
            return null;
        }
        return list.find((seat) => seat.id === seatId) || null;
    }

    
    
}
